<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      fixed  
      dark
      app      
      v-if="!guest"
    >
    <v-list subheader v-for="item in items" :key="item.text">
      <v-subheader>{{item.text}}</v-subheader>

      <v-list-item
        v-for="subItem in item.items"
        :key="subItem.text"
        @click="subItem.link && $router.push(subItem.link)"
      >
        <v-list-item-avatar>
          <v-icon>{{ subItem.icon }}</v-icon>
        </v-list-item-avatar>
        
        <v-list-item-content>
          <v-list-item-title v-text="subItem.text"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </v-navigation-drawer>


  <v-app-bar        
    app
    fixed 
    dark   
    v-if="!guest"
  >    
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-toolbar-title>
      <span class="title">ManyConvert</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn fab @click="$router.push('profile')">
      <v-icon>account_circle</v-icon>
    </v-btn>
  </v-app-bar>

  <v-content>
    <router-view></router-view>
  </v-content>

  <v-snackbar
    v-model="$store.state.snackbar.open"
    :color="$store.state.snackbar.color"      
    :timeout="3000"      
  >
    {{$store.state.snackbar.text}}
  </v-snackbar>
  <v-dialog
    v-model="$store.state.loading"
    hide-overlay
    persistent
    width="300"
    >
      <v-card
        color="default"
        dark
      >
        <v-card-text>
          Carregando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
  </v-dialog>
</v-app>
</template>

<script>
  export default {
    computed: {
      guest(){
        return !this.$store.state.user;
      }
    },
    sockets: {
      connect() {
        if (this.$store.state.user) {
          this.$socket.emit('setUser', this.$store.state.user);
        }
      },
      welcome(val) {
        console.log('ok')
      },
      newSale(msg) {
        console.log('newSale', msg);
        this.$store.commit('alertSuccess', msg);
      }
    },
    methods: {
      logout () {        
        this.$store.dispatch('logout');
      }
    },
    beforeCreate() {
      /*
      * Check if there is user information
      * in localStorage before the main component is mounted
      */
      if (localStorage.getItem('access_token')) {
        let data = localStorage.getItem('user');
        if (data) {
          data = JSON.parse(data);
          this.$store.dispatch('setUser', {data});
          this.$socket.emit('setUser', data);
        }
      }
    },
    data: () => ({
      drawer: null,
      items: [
        {          
          items:[
            { icon: 'dashboard', text: 'Dashboard', link: '/dashboard' },
          ]
        },
        // {
        //   text: 'Automação',
        //   items:[*/
        //     { icon: 'dashboard', text: 'Dashboard', link: '/dashboard' },
        //     { icon: 'list', text: 'Transações', link: '/transactions' },
        //     { icon: 'person', text: 'Base de Leads', link:'/leads' },
        //     { icon: 'person', text: 'Segmentação', link:'/lead-segmentations' },
        //     { icon: 'email', text: 'E-mails', link: '/email'},
        //     { icon: 'account_circle', text: 'Configurações' , link: '/profile'},
        //   ]
        // },
        { 
          text: 'Conversão', 
          items: [
            { icon: 'store', text: 'Lojas', link: '/stores'},
            { icon: 'person', text: 'Atendentes', link: '/attendants'},            
            // { icon: 'message', text: 'Mensagens', link: '/messages'},
            { icon: 'event', text: 'Agendamentos', link: '/attending-schedules'},
            { icon: 'local_atm', text: 'Pagos', link: '/paid'},
            // { icon: 'event', text: 'Vencidos', link: '/expired'},
          ]
        },
        { 
          text: 'Relatórios',
          items: [            
            { icon: 'person', text: 'Atendentes', link: '/reports'},            
            /*{ icon: 'message', text: 'Mensagens', link: '/messages'},*/
          ]
        },
        { 
          text: 'Notificações Automáticas', 
          items: [
            { icon: 'whatsapp', text: 'Sessões', link: '/sessions'},
            { icon: 'message', text: 'Notificações', link: '/notifications'},
          ]
        },
        { 
          text: 'Sistema', 
          items: [
            { icon: 'widgets', text: 'Integração', link: '/integrations/google'},
            { icon: 'logout', text: 'Sair', link: '/logout'},
          ]
        },
      ],
    }),
    props: {
      source: String
    }
  }
</script>
